/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export { NzResizeObserverModule } from './resize-observer.module';
export { NzResizeObserverDirective } from './resize-observer.directive';
export { NzResizeObserver, NzResizeObserverFactory } from './resize-observer.service';
